import { OpenDay } from 'apollo/types';

const getLastOpenDay = (openDays: OpenDay[] | undefined): OpenDay | undefined => {
  if (!openDays?.length) {
    return undefined;
  }

  const lastOpenDay = openDays.reduce((maxOpenDay: OpenDay, currentOpenDay) => {
    const currentMaxDate = maxOpenDay ? maxOpenDay.day : null;
    const currentDate = currentOpenDay.day;

    return !currentMaxDate || currentDate > currentMaxDate ? currentOpenDay : maxOpenDay;
  });
  return lastOpenDay;
};

export default getLastOpenDay;
